<template>
    <BaseLayout>
        <div class="container">
            <SearchFilter class="my-4" />
            <div v-if="$page.props.vehicles.data.length">
                <div class="row g-3 align-items-center justify-content-between my-4">
                    <div class="col-auto">
                        <div class="fs-15">Showing {{ $page.props.vehicles.from }} - {{ $page.props.vehicles.to }} of {{ $page.props.vehicles.total }} results</div>
                    </div>
                    <div class="col-auto hstack gap-2">
                        <div class="ff-15 text-nowrap">Sort by</div>
                        <div class="dropdown">
                            <button class="btn bg-white rounded-3 border d-flex min-w-150" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <div class="me-auto text-capitalize">{{ route().params.sort ?? 'Latest' }}</div>
                                <i class="fas fa-sort-down"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end rounded-4">
                                <li>
                                    <Link class="dropdown-item" :href="route('front.vehicles.index', route().params)" :data="{ sort: 'latest' }" :only="['vehicles']" preserve-scroll preserve-state>Latest</Link>
                                    <Link class="dropdown-item" :href="route('front.vehicles.index', route().params)" :data="{ sort: 'oldest' }" :only="['vehicles']" preserve-scroll preserve-state>Oldest</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row row-cols-xl-2 row-cols-1 g-4">
                    <div class="col" v-for="vehicle in $page.props.vehicles.data">
                        <VehicleCard :vehicle="vehicle"/>
                    </div>
                </div>
                <Pagination class="my-5 justify-content-center" :elements="$page.props.vehicles"/>
            </div>
            <div class="my-4" v-else>
                No result
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { Link , usePage } from '@inertiajs/vue3';
import { ref } from 'vue';

import BaseLayout from '../../../../../../resources/js/front/Layouts/BaseLayout.vue';
import VehicleCard from '../../../../../../resources/js/front/Components/VehicleCard.vue';
import Pagination from '../../../../../../resources/js/front/Components/Pagination.vue';
import SearchFilter from '../../../../../../resources/js/front/Components/SearchFilter.vue';

const page = usePage();

const sort = ref(page.props.ziggy.query.sort);

</script>
